import { Injectable } from '@angular/core';
import { v4 as uuid } from 'uuid';

import {
  DprActivityCustomDataGridData,
  DprActivityGridData,
  DprForecastActivityCustomDataGridData,
  DprForecastActivityGridData,
} from '@dpr-details/models/grid';
import { SelectedSubproject } from '@shared/models';

@Injectable()
export class DprActivityCustomDataService {
  buildCustomDataGridData(
    selectedSubproject: SelectedSubproject,
    entity: DprActivityGridData
  ): DprActivityCustomDataGridData[] {
    return selectedSubproject.data.activityMobilisationList
      .filter(
        (x) =>
          x.activityId === entity.activityId &&
          (x.parallelActivityType ?? 0) === (entity.parallelActivityType ?? 0)
      )
      .reduce((acc, curr) => {
        const customData = selectedSubproject.data.customDataList.find(
          (x) => x.id === curr.customDataId
        );

        const dprActivityCustomDataMerged =
          entity.dprActivityCustomDataList ?? [];
        const dprActivityCustomData = dprActivityCustomDataMerged.find(
          (x) => x.customDataId === curr.customDataId
        );

        if (!curr.isActive && !dprActivityCustomData) {
          return acc;
        }

        return [
          ...acc,
          {
            id: dprActivityCustomData?.id ?? uuid(),
            customDataId: customData.id,
            dataTypeId: customData.dataTypeId,
            decimalCount: customData.decimalCount,
            name: customData.name,
            remark: customData.remark,
            priority: customData.priority,
            dprActivityId: dprActivityCustomData?.dprActivityId,
            value: dprActivityCustomData?.value ?? null,
            comment: dprActivityCustomData?.comment,
            booleanTerminologyId: customData.booleanTerminologyId,
          },
        ];
      }, []);
  }

  buildForecastCustomDataGridData(
    selectedSubproject: SelectedSubproject,
    entity: DprForecastActivityGridData
  ): DprForecastActivityCustomDataGridData[] {
    return selectedSubproject.data.activityMobilisationList
      .filter(
        (x) => x.activityId === entity.activityId && !x.parallelActivityType
      )
      .reduce((acc, curr) => {
        const customData = selectedSubproject.data.customDataList.find(
          (x) => x.id === curr.customDataId
        );

        const dprActivityCustomDataMerged =
          entity.dprForecastActivityCustomDataList ?? [];

        const dprActivityCustomData = dprActivityCustomDataMerged.find(
          (x) => x.customDataId === curr.customDataId
        );

        if (!curr.isActive && !dprActivityCustomData) {
          return acc;
        }

        return [
          ...acc,
          {
            id: dprActivityCustomData?.id ?? uuid(),
            customDataId: customData.id,
            dataTypeId: customData.dataTypeId,
            decimalCount: customData.decimalCount,
            name: customData.name,
            remark: customData.remark,
            dprForecastActivityId: dprActivityCustomData?.dprForecastActivityId,
            value: dprActivityCustomData?.value ?? null,
            comment: dprActivityCustomData?.comment,
            booleanTerminologyId: customData.booleanTerminologyId,
          },
        ];
      }, []);
  }
}
